import axios from 'axios';

const getFindingImage = async (patrolId, id) => axios.get(`patrols/${patrolId}/findings/${id}/image`);

const updateFinding = async (patrolId, id, body) => axios.patch(`patrols/${patrolId}/findings/${id}`, body);

const updateFindingType = async (patrolId, id, body) => axios.patch(`patrols/${patrolId}/findings/${id}/type`, body);

export default {
  getFindingImage,
  updateFinding,
  updateFindingType,
};
